var CustomOverlay = function (data, opts) {
  var view = data;

  return view.render();
};

module.exports = CustomOverlay;



//////////////////
// WEBPACK FOOTER
// ./~/cartodb.js/src/vis/overlays/custom.js
// module id = 1700
// module chunks = 6